import generalSection from "../_section/section.class";
import {userAccountStatementUpload, adminAccountStatementUpload} from "./upload";
import BalancesForm from "./BalancesForm.js";
import DataForm from "./DataForm";
import ApplicationForm from "./ApplicationForm";
import problem from "../_section/section-problem.class";
import dayjs from "dayjs";

export const MONTHS_REQUIRED = 6

export class userAccountStatementSection extends generalSection {


    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userAccountStatementUpload);

        // Sort uploads with newest first
        this.uploads.sort((a, b) => {
            if (!a.isActive) {
                return 1
            }
            if (!b.isActive) {
                return -1
            }
            if (!a?.dateData?.range?.from?.date) { // no dates to go top
                return -1
            }
            if (!b?.dateData?.range?.from?.date) {

                return 1
            }
            if (a.dateData.range.from.date.isSame(b.dateData?.range.from.date, 'day')) {
                return 0; // If dates are the same, keep original order
            }
            return a.dateData.range.from.date.isBefore(b.dateData.range.from.date) ? 1 : -1;
        });
        // Set array of the upload ranges that we have (corrected for overlapping dates & ignoring alignment dates)
        this.setUploadsRanges(
            (() => {
                const activeUploads = [...this.uploads].reverse().filter(it => it.isActive && it.isVerifiable);
                return activeUploads.flatMap((upload, uploadIndex) => {
                    if (!upload?.dateData?.range?.ok) {
                        return [];
                    }
                    const nextUploadWithOpening = activeUploads.find((it, i) => i > uploadIndex && it?.dateData?.range?.from?.date);
                    const openingDateOfNextUpload = nextUploadWithOpening ? nextUploadWithOpening?.dateData?.range?.from?.date : null;
                    // if there are start or end props available, use them, as they are the dates on the alignment endDate/startDate

                    let thisEnd = upload?.dateData?.range?.to ? upload.dateData.range.to : null
                    let thisStart = upload?.dateData?.range?.from ? upload.dateData.range.from : null


                    // this now updates the current upload end date, if the next upload opening date is before it
                    if (thisEnd?.date && openingDateOfNextUpload && openingDateOfNextUpload.local().startOf('day').isBefore(thisEnd.date)) {
                        let neededEndDate = openingDateOfNextUpload
                        const balanceFoundOnThisDay = upload.balances.find(it => it.date.isSame(neededEndDate, 'day'));
                        if (balanceFoundOnThisDay) {
                            thisEnd = balanceFoundOnThisDay;
                        } else {
                            thisEnd = {
                                date: neededEndDate,
                                balance: null // to detect if null to make error later!
                            }
                        }
                    }
                    if (thisStart?.date && !thisStart.balance) {
                        const balanceFoundOnThisDay = upload.balances.find(it => it.date.isSame(thisStart.date, 'day'));
                        if (balanceFoundOnThisDay) {
                            thisStart = balanceFoundOnThisDay;
                        }
                    }
                    if (thisEnd?.date && !thisEnd.balance) {
                        const balanceFoundOnThisDay = upload.balances.find(it => it.date.isSame(thisEnd.date, 'day'));
                        if (balanceFoundOnThisDay) {
                            thisEnd = balanceFoundOnThisDay;
                        }
                    }
                    return [
                        {
                            start: thisStart,
                            end: thisEnd,
                            uploadId: upload.id,
                            balanceOnDate: (date) => {

                                if (date.toISOString() !== date.startOf('day').toISOString()) {
                                    throw new Error('Date must be local and start of day');
                                }
                                if (upload.isDateInUpload(date)) {
                                    return upload.balanceOnDate(date);
                                }
                                return null
                            }
                        }
                    ]
                })
            })()
        )

    }

    LOG = (...args) => {

    }
    balanceOnDate = (date) => {
        date = date.local().startOf('day');
        const response = {}
        const uploadsContainingDate = this.uploads.filter(upload => upload.isActive && upload.isVerifiable && upload.isDateInUpload(date));
        this.LOG({section: this, uploadsContainingDate, date: date})
        if (uploadsContainingDate.length === 0) {
            response.errors = [`No uploads found`];
        } else if (uploadsContainingDate.length > 1) {
            response.errors = [`Multiple uploads found`];
        }
        const balanceUpload = uploadsContainingDate.find(upload => upload.balanceOnDate(date).balance != null);

        if (!balanceUpload) {
            response.errors = [`No balance found`];
        } else {
            response.balance = balanceUpload.balanceOnDate(date).balance;
        }

        return response
    }
    adjustmentsBetweenDates = (startDate, endDate) => {
        const adjustments = [];
        this.uploads.forEach(upload => {
            if (!upload.isActive) return;
            const uploadAdjustments = upload.adjustmentsBetweenDates(startDate, endDate).map(it => ({
                ...it,
                accountTitle: this.personalTitle
            }));

            if (uploadAdjustments.length > 0) {
                adjustments.push(...uploadAdjustments);
            }
        });
        const value = adjustments.reduce((acc, curr) => {
            if (curr.direction === 'UP') {
                return acc + curr.amount;
            } else if (curr.direction === 'DOWN') {
                return acc - curr.amount;
            }
            return acc;
        }, 0)
        return {adjustments, value};
    }


    financesInRange = (startDate, endDate) => {
        const convertRate = !(!this.data.currency || this.data.currency.toLowerCase().trim().startsWith('eur') || this.data.currency.trim() === '€') ? this.mortgage.requirement.accountingFx[this.data.currency] ? this.mortgage.requirement.accountingFx[this.data.currency] : 1 : null
        const section = {}
        section.applicant = this.applicant;
        section.personalTitle = this.personalTitle;
        section.institution = this.data?.institution || null;
        section.key = this.name + (this.index ? ":" + this.index : "")
        section.ownerName = this?.data?.joint ? 'Joint' : this.ownerName
        section.openingOnDate = this.data?.isNewAccount ? {balance: 0, date: this.summary.range.from?.date} : this.balanceOnDate(startDate).balance;
        section.closingOnDate = this.data?.isClosed ? {balance: 0, date: this.summary.range.to?.date} : this.balanceOnDate(endDate).balance;
        section.institution = this.data.institution
        section.currency = this.data.currency || null
        section.difference = (section.closingOnDate?.balance != null && section.openingOnDate?.balance != null) ? section.closingOnDate.balance - section.openingOnDate.balance : null;
        const {adjustments, value} = this.adjustmentsBetweenDates(startDate, endDate)
        section.adjustmentRows = adjustments
        section.adjustments = value

        section.total = (() => {
            let tot = 0
            if (section.difference != null) {
                tot += Number(section.difference)
            }
            if (section.adjustments != null) {
                tot += Number(section.adjustments)
            }


            return Number(tot.toFixed(2));
        })()
        section.convertedTotal = (() => {
            if (convertRate) {
                return Number((section.total / convertRate).toFixed(2))
            }
            return null
        })()
        /*
        I need to adjust savings rate for 2 queries - the €1,665 for RMF and also the €2,900 for Orla Lonergan - I keep getting an error when I have tried to adjust after the query was input but was getting an error. I then tried putting the query back in and using the 'rd' but I am also getting an error....
         */
        section.averageSavings = Number((section.total / MONTHS_REQUIRED).toFixed(2))
        section.convertedAverageSavings = (() => {
            if (convertRate) {
                return  Number((section.averageSavings / convertRate).toFixed(2))
            }
            return null
        })()
        section.convertRate = convertRate
        section.includeInCalculations = this?.progress?.includeInCalculations
        section.uploads = this.uploads.filter(upload => upload.isActive);
        section.requiredRange = {start: startDate, end: endDate};
        section.progressID = this.progress?.id;
        section.accommodationDD = this?.data?.accommodationDD
        section.savingFrequency = this?.data?.increasesFrequency
        section.salaried = this?.data?.salaried
        section.isClosedAccount = this.data?.isClosed
        section.isNewAccount = this?.data?.isNewAccount
        section.joint = this?.data?.joint
        if (this.uploadsRanges.length) {
            section.fullRange = {
                from: this.uploadsRanges[0].start,
                to: this.uploadsRanges[this.uploadsRanges.length - 1].end
            }
        }
        section.comments = this?.uploadsOffice?.coverNoteQueries

        return section


    }


    setAlignmentDate(endDate) {
        this.statementAlignmentDate = endDate;
    }

    requiredRangeText = ()=>{
        let endDate = this.statementAlignmentDate || dayjs().subtract(1,'month').endOf('month').local().startOf('day');
        let startDate = endDate.clone().subtract(MONTHS_REQUIRED, 'months').add(1, 'day');
        return `${startDate.format('D MMM YYYY')} to ${endDate.format('D MMM YYYY')}`
    }
    get currency() {
        return this.data?.currency || null
    }
}

export class adminAccountStatementSection extends userAccountStatementSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminAccountStatementUpload);
        this.sortByDateProp('startDate')
        this.BalancesForm = BalancesForm
        this.DataForm = DataForm
        this.ApplicationForm = ApplicationForm
        this.setProblems(this.getProblems())
    }


    getProblems() {
        const problems = []
        // check if updateAtPreApproval exists use that instead of statementAlignmentDate, the last date of the last upload is needed
        problems.push(...(this.problemsList.universalVerifiedUploadProblems() || []));


        if (this?.progress?.requiredRanges?.length){

            const start = this.progress.requiredRanges[0]?.start ? dayjs(this.progress.requiredRanges[0].start) : null;
            const end = this.progress.requiredRanges[0]?.end ? dayjs(this.progress.requiredRanges[0].end) : null;

            const expandedRange = this.calcExpandedRange(start, end)
            //console.log('Getting required range')
                 //console.log({X: this.problemsList.missingInExpandedRange(expandedRange), expandedRange})

            problems.push(...this.problemsList.missingInExpandedRange(expandedRange))
            //  console.log({missing : this.problemsList.missingInExpandedRange(expandedRange)})
        }
        else if (this.statementAlignmentDate) {
            const expandedRange = this.calcExpandedRange(this.statementAlignmentDate.add(1, 'day').subtract(6, 'months'), this.statementAlignmentDate);
            problems.push(...this.problemsList.missingInExpandedRange(expandedRange))
        }
        else if (this.data?.updateAtPreApproval && this.name.startsWith('updated-statements')) {

            // get the section for this account, in bank-statements
            const startDate = this.summary?.range?.to?.date?.add(1, 'day')
            const endDate = dayjs(this.data.updateAtPreApproval, 'YYYY-MM-DD').local().startOf('day');



            // no uploads
            if (!this.uploads.filter(it=>it.props.upload.section.startsWith('updated-statements')).length) {

                problems.push(new problem({
                    type: 'USER',
                    enum: 'NOT_STARTED',
                    title: `No Uploads: `,
                    reason: 'No uploads available',
                    message: `Uploads not started`,
                    userMessage: `Not started`,
                }))

                problems.push(new problem({
                        type: 'BUNDLE',
                        title: 'No Uploads',
                        message: `No active uploads`,
                    })
                )
            } else {
                const activeUploads = this.uploads.filter(u => u.isActive && u.isVerifiable && u.props.upload.section.startsWith('updated-statements'));
                if (!activeUploads.length) {
                    if (startDate && endDate) {
                        problems.push(new problem({
                            type: 'USER_ALERT',
                            enum: 'NO_ACTIVE_UPLOADS',
                            body: 'Another Upload Needed',
                            title: `No active uploads (Min Period: ${startDate.format('D MMM YYYY')} to ${endDate.format('D MMM YYYY')} )`,
                        }))
                    }
                    problems.push(new problem({
                        type: 'BUNDLE',
                        title: 'No Active Uploads',
                        message: `No active uploads`,
                    }))
                }

            }
            if (startDate && endDate) {
                const expandedRange = this.calcExpandedRange(startDate, endDate);
                problems.push(...this.problemsList.missingInExpandedRange(expandedRange))
            }


        }

        else{
            const endDate = dayjs().subtract(1,'month').endOf('month').local().startOf('day');
            const startDate = endDate.clone().subtract(6, 'months').add(1, 'day');
            const expandedRange = this.calcExpandedRange(startDate, endDate);
            problems.push(...this.problemsList.missingInExpandedRange(expandedRange))
        }


        if (!this.data?.accountNumber) {
            problems.push(new problem({
                type: "BUNDLE",
                title: 'Account No not set',
                message: 'Account No missing in Application Data',
            }))
        } else {
            let mismatch = false;
            this.activeUploads.forEach(upload => {
                const problematic = upload.values.iban && upload.values.iban.replace(/\s/g, '').toUpperCase() !== this.data.accountNumber.replace(/\s/g, '').toUpperCase()
                if (problematic) {
                    mismatch = true;
                    // upload.problems.push('Account No Mismatch')
                }
            })
            if (mismatch) {
                problems.push(new problem({
                    type: "BUNDLE",
                    title: 'Account No Mismatch',
                    message: 'Account No Mismatch',
                }))
            }
        }

        if (!['APPLY','SETUP'].includes(this.mortgage.applicationStage) &&  this.activeUploads.some(upload => upload.isVerifiable && !upload.isExamined)) {
            problems.push(new problem({
                type: "BUNDLE",
                title: 'Upload not examined',
                message: 'One or more uploads have not been examined',
            }))
        }
        if (this.activeUploads.some(upload => {
            // find any other update with same start date and end date
            if (!upload.isVerifiable) return false;
            return this.activeUploads.some(otherUpload => otherUpload.id !== upload.id && otherUpload.isVerifiable && otherUpload.dateData?.range?.from?.date && upload.dateData?.range?.from?.date && otherUpload.dateData.range.from.date.isSame(upload.dateData.range.from.date, 'day') && otherUpload.dateData?.range?.to?.date && upload.dateData?.range?.to?.date && otherUpload.dateData.range.to.date.isSame(upload.dateData.range.to.date, 'day'))
        })) {

            problems.push(new problem({
                type: "BUNDLE",
                title: 'Duplicate uploads',
                message: 'Two or more uploads have the same start and end dates',
            }))

        }


        if (!this.data?.updateAtPreApproval) {

            problems.push(...this.problemsList.summaryRangeTooShort(6, 'months'))
        }


        const missingBalances = this.uploads.filter(upload => upload.isActive && upload.isVerifiable && !upload?.dateData?.range?.ok).length;
        if (missingBalances) {
            problems.push(new problem({
                type: "DATA",
                title: 'Missing Balances',
                message: 'Missing Balances',
            }))
        }
        if (!problems.length) {
            // if (!this.summary?.range?.from?.date && !this.summary?.range?.to?.date){
            //     const diffInRange = this.summary?.range?.to?.date?.diff(this.summary?.range?.from?.date, 'month', true) || 0;
            //     if (diffInRange < MONTHS_REQUIRED) {
            //         upload-steps.push(new problem({
            //             type: "BUNDLE",
            //             title: 'Not enough months',
            //             message: `Range required ${MONTHS_REQUIRED} months, but it is only ${Math.ceil(diffInRange)} months long.`,
            //         }))
            //     }
            // }ValuesClosing
        }

        return problems;
    }

    getSectionSummary = () => {
        const closingOnDate = this.summary?.range?.to || null;
        const closingBalanceInLocal = closingOnDate?.balance ?? null;
        console.log({that:this, closingOnDate})
        const currency = this.currency;
        const isEuro = !currency || currency.toLowerCase().trim().startsWith('eur') || currency.trim() === '€';
        const accountingFx = !isEuro ? (this.mortgage?.requirement?.accountingFx?.[currency] || 1) : null;

        const closingBalanceInEuro = closingBalanceInLocal != null
            ? (accountingFx ? Number((closingBalanceInLocal / accountingFx).toFixed(2)) : closingBalanceInLocal)
            : null;
        const tags = []
        if (closingOnDate?.date) {
            tags.push({
                name: `Last Date`,
                value: closingOnDate.date.format('D MMM YYYY')
            })
        }
        if (closingBalanceInEuro != null) {
            tags.push({
                name: `Balance €`,
                value: `€${closingBalanceInEuro?.toLocaleString()}`
            })
        }
        if (!isEuro) {
            tags.push({
                name: `Balance ${currency}`,
                value: `${currency}${closingBalanceInLocal?.toLocaleString()}`
            })
        }
        return [{
            name: `${this.personalTitle} ${this.data.accountNumber}`,
            tags: tags,
        }]
    }
}